import axios from 'axios';

export const sendToMagentoCart = (products) => {
  const baseUrl = process.env.VUE_APP_MAGENTO_URL;
  const data = {
    products: products,
    environmentId: parseInt(process.env.VUE_APP_ENVIRONMENT),
  };

  return axios
    .post(baseUrl + '/configurator/addtocart', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    .then((res) => {
      axios
        .post(baseUrl + '/configurator/quoterecollect', data, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((res) => {
          if (typeof window.require === 'function') {
            window.require(
              ['Magento_Customer/js/customer-data'],
              function (customerData) {
                const sections = ['cart'];
                customerData.invalidate(sections);
                customerData.reload(sections, true);
              }
            );
          }

          return res;
        });

      return res;
    });
};
